import React, { useContext, useMemo } from 'react'
import { format } from 'date-fns'
import GreenIcon from '@/assets/img__bio_alert__green.svg?react'
import RedIcon from '@/assets/img__bio_alert__red.svg?react'
import { IAlertEmergencyLiveItem, EmergencyAlertType } from '@/api/notification/getLiveEmergencyAlert.ts'
import { IAlertFallDetectionLiveItem } from '@/api/notification/getLiveFallDetectionAlert.ts'
import { EmergencyLiveAlertContext } from '@/pages/notification/emergency/EmergencyAlertModal.tsx'
import useQueryGetMe from '@/api/auth/getMe.ts'
import { useTranslation } from 'react-i18next'

export interface IProps {
    className?: string;
    item: IAlertEmergencyLiveItem | IAlertFallDetectionLiveItem;
    alertType: EmergencyAlertType;
}

const EmergencyAlertItem: React.FC<IProps> = ({ className, item, alertType }) => {
    const { t } = useTranslation()
    const { data: me } = useQueryGetMe()
    const { id, protectee, alert } = item;
    
    // 특정 이메일 계정인지 확인
    const isMaskingRequired = useMemo(() => {
        return me?.email === 'dbd_cm@clomental.com'
    }, [me?.email])
    
    const renderStatusIcon = useMemo(() => {
        if (alert?.taskManagerAt) {
            return <GreenIcon />
        } else {
            return <RedIcon />
        }
    }, [alert?.taskManagerAt])

    const { id: selectedId, setId } = useContext(EmergencyLiveAlertContext)

    const isSelected = useMemo(() => {
        return id == selectedId
    }, [id, selectedId])

    // 알림 타입에 따른 클래스 설정
    const getItemClassName = () => [
        className || '',
        'emergency-alert-item',
        isSelected ? 'is-selected' : '',
        alertType === EmergencyAlertType.FALL ? 'emergency-alert-item--fall' : '',
        alert?.isMyTask && selectedId != id ? 'is-my-task' : ''
    ].filter(Boolean).join(' ')

    // 알림 타입에 따른 아이콘 표시
    const getStatusLabel = () => {
        if (alert?.taskManagerAt) {
            return t('notification.sosModal.list.item.allotment')
        } else {
            return t('notification.sosModal.list.item.new')
        }
    }

    return <button
        type="button"
        className={getItemClassName()}
        aria-pressed={isSelected}
        onClick={() => setId(id)}>
        <span className="emergency-alert-item__status">{renderStatusIcon}</span>
        <span className="emergency-alert-item__content">
            <strong>{isMaskingRequired ? (protectee?.name ? protectee?.name.charAt(0) + '**' : '***') : protectee?.name}</strong>
            <small>{format(alert?.createdAt, 'HH:mm:ss')} · {getStatusLabel()}</small>
        </span>
        <span className="emergency-alert-item__type">
            {alertType === EmergencyAlertType.FALL ? t('notification.sosModal.list.item.fall') : 'SOS'}
        </span>
        <span className="emergency-alert-item__arrow" aria-hidden>›</span>
    </button>
}

export default EmergencyAlertItem
